import { render, staticRenderFns } from "./ProductSpecs.vue?vue&type=template&id=6cb8af7a&scoped=true&"
import script from "./ProductSpecs.vue?vue&type=script&lang=js&"
export * from "./ProductSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb8af7a",
  null
  
)

export default component.exports